import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-rows: 20px;
  grid-template-columns: 1fr;
  grid-gap: 0.5rem;
`;
